// English

const lang = {
  gateMediaPreviewHeader: 'You may also like',
  loadmore: 'Show more',
  nextMedia: 'Next media',
  previousMedia: 'Previous media',
  closePost: 'Close post',
  nextPost: 'Next post',
  previousPost: 'Previous post',
  outOfStock: 'Out of stock',
  numberOfReviews(n) {
    return n === 1 ? 'review' : 'reviews'
  },
  reportFormField: 'Please enter a message',
  reportPost: 'Report post',
  reportFormTitle: 'Do you want to report this image?',
  reportFormDetails:
    'If you believe that the image is inappropriate, illegal or infringes someone’s rights, you can report the content. If you report the image / text, the content moderators will be notified and the appropriate action will be taken.',
  reportFormMessagePlaceholder: 'State the reason for your report',
  reportFormMessageLabel: 'Message',
  reportFormEmailLabel: 'Your email',
  reportFormSubmitButtonText: 'Submit Report',
  reportFormCancelButtonText: 'Cancel',
  reportFormSentTitle: 'Thank you for your report!',
  reportFormSentCloseButtonText: 'Close',
  cardAndTileAriaLabel: 'List of posts from accounts on various social media platforms',
  carouselAriaLabel: 'Carousel with posts from accounts on various social media platforms',
  singleAriaLabel: 'Post from a social media account',
  poweredBy: 'Powered by Flowbox',
  postAltText: (userName, date) => {
    const createdByString = userName ? ` by ${userName}` : ''
    const publishedString = date ? ` published at ${date}` : ''
    return `Photo${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Upload your Media',
  openTheGate: 'Open the dialog',
  gridRoleDescription: 'grid',
  carouselRoleDescription: 'carousel',
  tiktokVideoAriaLabel: 'Embedded TikTok video. Press play to view content.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Media thumbnail ${postIndex + 1} of ${maxPosts}, opens dialog with social media content and featured product list.`,
  carouselControlButtonsAriaLabel: 'Carousel control buttons',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `Media ${mediaIndex + 1} out of ${maxMedia}`,
  showMoreCaption: 'Show more caption',
  showLessCaption: 'Show less caption',
  originalPrice: (price) => `Original price: ${price}`,
  salesPrice: (price) => `Sales price: ${price}`,
  postPublishedBy: 'Post published by',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Video' : 'Image'
    const user = username ? `${username}` : 'unknown user'
    const publishDate = date ? `on ${date}` : ''
    return `${mediaType} posted by ${user} ${publishDate}. It can be ${altText}`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Post ${postIndex + 1} of ${maxPosts}.`,
}

export default lang
